import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';

import {
  ProductTypes,
  ProductInterface,
  TicketResevationInterface,
} from './types';

// List Products
export const listProductsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(ProductTypes.LIST_PRODUCTS_REQUEST, payload);

export const listProductsSuccess = (payload: {
  productsList: ProductInterface[];
  totalCount: number;
}) => action(ProductTypes.LIST_PRODUCTS_SUCCESS, payload);

export const listTicketResavationSuccess = (payload: {
  ticketResavationList: TicketResevationInterface[];
  totalCount: number;
}) => action(ProductTypes.LIST_TICKET_RESAVATION_SUCCESS, payload);

export const listProductsFailure = () =>
  action(ProductTypes.LIST_PRODUCTS_FAILURE);

// Filter Product
export const filterProductsRequest = (payload: object) =>
  asyncAction(ProductTypes.FILTER_PRODUCTS_REQUEST, payload);

export const filterProductsSuccess = (payload: {
  productsList: ProductInterface[];
  totalCount: number;
}) => action(ProductTypes.FILTER_PRODUCTS_SUCCESS, payload);

export const filterProductsFailure = () =>
  action(ProductTypes.FILTER_PRODUCTS_FAILURE);

// Create Product
export const createProductRequest = (payload: object) =>
  action(ProductTypes.CREATE_PRODUCT_REQUEST, payload);

export const createProductSuccess = (payload: { product: ProductInterface }) =>
  action(ProductTypes.CREATE_PRODUCT_SUCCESS, payload);

export const createProductFailure = () =>
  action(ProductTypes.CREATE_PRODUCT_FAILURE);

// Update Product
export const updateProductRequest = (payload: object) =>
  action(ProductTypes.UPDATE_PRODUCT_REQUEST, payload);

export const updateProductSuccess = (payload: { product: ProductInterface }) =>
  action(ProductTypes.UPDATE_PRODUCT_SUCCESS, payload);

export const updateProductFailure = () =>
  action(ProductTypes.UPDATE_PRODUCT_FAILURE);

// Delete Product
export const deleteProductRequest = (payload: object) =>
  action(ProductTypes.DELETE_PRODUCT_REQUEST, payload);

export const deleteProductSuccess = () =>
  action(ProductTypes.DELETE_PRODUCT_SUCCESS);

export const deleteProductFailure = () =>
  action(ProductTypes.DELETE_PRODUCT_FAILURE);
